import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Centered results empty state: illustration + title + description (+ optional action).
 */
export default function ResultsEmptyState({
  title,
  description,
  illustration,
  action = null,
  testId = "results-empty-state",
}) {
  return (
    <Box
      data-testid={testId}
      sx={{
        width: "100%",
        minHeight: { xs: 320, md: 420 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: { xs: 5, md: 8 },
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          maxWidth: 420,
        }}
      >
        <Box
          aria-hidden="true"
          sx={{
            mb: 2.5,
            width: { xs: 148, md: 168 },
            height: { xs: 148, md: 168 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {illustration}
        </Box>

        <Typography
          component="h2"
          sx={{
            m: 0,
            mb: 1,
            fontWeight: 800,
            fontSize: { xs: 18, md: 20 },
            lineHeight: 1.25,
            letterSpacing: "-0.02em",
            color: "#111827",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            m: 0,
            fontWeight: 400,
            fontSize: { xs: 13.5, md: 14 },
            lineHeight: 1.5,
            color: "#58595B",
            maxWidth: 360,
          }}
        >
          {description}
        </Typography>

        {action ? (
          <Box sx={{ mt: 2.5, display: "flex", justifyContent: "center" }}>
            {action}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
